class CookieConsent {
  constructor() {
    this.cookieName = 'cookie_consent';
    this.cookieExpiry = 365; // days
    this.init();
  }

  init() {
    // Check if consent already given
    if (!this.getCookie(this.cookieName)) {
      this.showConsent();
    } else {
      const consent = this.getCookie(this.cookieName);
      if (consent === 'accepted') {
        this.loadCookies();
      }
    }

    // Add event listeners
    const acceptButton = document.getElementById('cookie-accept');
    const rejectButton = document.getElementById('cookie-reject');

    if (acceptButton) {
      acceptButton.addEventListener('click', () => this.acceptCookies());
    }

    if (rejectButton) {
      rejectButton.addEventListener('click', () => this.rejectCookies());
    }
  }

  showConsent() {
    const consentBox = document.getElementById('cookie-consent');
    if (consentBox) {
      consentBox.style.display = 'block';
      // Add animation
      setTimeout(() => {
        consentBox.style.opacity = '1';
        consentBox.style.transform = 'translateY(0)';
      }, 10);
    }
  }

  hideConsent() {
    const consentBox = document.getElementById('cookie-consent');
    if (consentBox) {
      consentBox.style.opacity = '0';
      consentBox.style.transform = 'translateY(100%)';
      setTimeout(() => {
        consentBox.style.display = 'none';
      }, 300);
    }
  }

  acceptCookies() {
    this.setCookie(this.cookieName, 'accepted', this.cookieExpiry);
    this.loadCookies();
    this.hideConsent();
  }

  rejectCookies() {
    this.setCookie(this.cookieName, 'rejected', this.cookieExpiry);
    this.removeCookies();
    this.hideConsent();
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  loadCookies() {
    // Load analytics, marketing cookies etc. here
    // Example: Google Analytics, Facebook Pixel, etc.
    // This is where you would initialize third-party scripts
    if (typeof window.gtag !== 'undefined') {
      // Google Analytics initialization
    }
  }

  removeCookies() {
    // Remove all cookies except essential ones
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

      // Don't remove essential cookies
      if (name !== this.cookieName && name !== '_shopify_y' && name !== '_shopify_s') {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      }
    }
  }
}

(() => {
  const runWhenIdle = (callback) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1800 });
      return;
    }

    window.setTimeout(callback, 700);
  };

  const isHomePage = () => {
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    return path === '/' || document.querySelector('.shopify-section[id*="image_banner"], .banner') !== null;
  };

  const markTemplate = () => {
    if (isHomePage()) {
      document.body.classList.add('template-index');
    } else if (window.location.pathname.includes('/collections/')) {
      document.body.classList.add('template-collection');
    } else if (window.location.pathname.includes('/products/')) {
      document.body.classList.add('template-product');
    } else if (window.location.pathname.includes('/search')) {
      document.body.classList.add('template-search');
    }
  };

  const getAssetBase = () => {
    const script = document.currentScript || document.querySelector('script[src*="cookie-consent.js"]');
    if (!script || !script.src) return '';
    return script.src.replace(/cookie-consent\.js(\?.*)?$/, '');
  };

  const loadStylesheet = (fileName) => {
    const base = getAssetBase();
    if (!base || document.querySelector(`link[href*="${fileName}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${base}${fileName}`;
    document.head.appendChild(link);
  };

  const loadHomeHeroHeaderFix = () => {
    markTemplate();
    if (document.body.classList.contains('template-index')) {
      loadStylesheet('choice-home-hero-header-fix.css');
    }
  };

  const loadDeferredStyles = () => {
    [
      'choice-deferred-cookie-consent.css',
      'choice-deferred-list-social.css',
      'choice-deferred-pinch-zoom.css',
    ].forEach(loadStylesheet);
  };

  loadHomeHeroHeaderFix();

  const initCookieConsent = () => {
    new CookieConsent();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      loadHomeHeroHeaderFix();
      runWhenIdle(initCookieConsent);
      runWhenIdle(loadDeferredStyles);
    });
  } else {
    runWhenIdle(initCookieConsent);
    runWhenIdle(loadDeferredStyles);
  }
})();

// Choice mobile home: place the header just below the campaign bar.
(() => {
  const GAP_PX = 2;

  const isHomePage = () => {
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    return path === '/' || document.body.classList.contains('template-index');
  };

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const setImportant = (element, property, value) => {
    if (element) element.style.setProperty(property, value, 'important');
  };

  const getHeaderGroup = (sectionHeader) => {
    return sectionHeader?.closest('.shopify-section-group-header-group') || document.querySelector('.shopify-section-group-header-group');
  };

  const getTopFromPreviousSections = (group, sectionHeader) => {
    if (!group || !sectionHeader) return 30;

    let top = 0;
    for (const child of Array.from(group.children)) {
      if (child === sectionHeader || child.contains(sectionHeader)) break;
      const rect = child.getBoundingClientRect();
      if (rect.height > 0) top += rect.height;
    }

    if (top < 20) {
      const bar = group.querySelector('.announcement-bar-section, .announcement-bar, .utility-bar, [id*="announcement"]');
      if (bar) top = bar.getBoundingClientRect().height;
    }

    return Math.max(26, Math.round(top + GAP_PX));
  };

  const lockHomeMobileHeader = () => {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    if (!isHomePage() || !isMobile()) {
      document.body.classList.remove('choice-home-mobile-header-lock');
      sectionHeader.style.removeProperty('top');
      sectionHeader.style.removeProperty('position');
      return;
    }

    const group = getHeaderGroup(sectionHeader);
    const wrapper = sectionHeader.querySelector('.header-wrapper');
    const header = sectionHeader.querySelector('.header');
    const top = getTopFromPreviousSections(group, sectionHeader);

    document.body.classList.add('template-index', 'choice-home-mobile-header-lock');

    setImportant(group, 'position', 'relative');
    setImportant(group, 'margin-bottom', '0');
    setImportant(group, 'background', 'transparent');

    setImportant(sectionHeader, 'position', 'absolute');
    setImportant(sectionHeader, 'top', `${top}px`);
    setImportant(sectionHeader, 'left', '0');
    setImportant(sectionHeader, 'right', '0');
    setImportant(sectionHeader, 'z-index', '1300');
    setImportant(sectionHeader, 'background', 'transparent');
    setImportant(sectionHeader, 'background-color', 'transparent');
    setImportant(sectionHeader, 'background-image', 'none');

    [wrapper, header].forEach((element) => {
      setImportant(element, 'background', 'transparent');
      setImportant(element, 'background-color', 'transparent');
      setImportant(element, 'background-image', 'none');
      setImportant(element, 'box-shadow', 'none');
      setImportant(element, 'border', '0');
    });

    setImportant(header, 'min-height', '4.4rem');
    setImportant(header, 'padding-top', '0');
    setImportant(header, 'padding-bottom', '0');
  };

  const scheduleLock = () => {
    window.requestAnimationFrame(lockHomeMobileHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLock);
  } else {
    scheduleLock();
  }

  [80, 250, 700, 1400, 2400].forEach((delay) => window.setTimeout(lockHomeMobileHeader, delay));
  window.addEventListener('resize', scheduleLock, { passive: true });
  window.addEventListener('load', lockHomeMobileHeader, { once: true });

  new MutationObserver(scheduleLock).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

// Choice accessibility: add a readable name to app-injected WhatsApp links.
(() => {
  const label = 'WhatsApp ile iletisime gec';
  const selector = 'a[href*="api.whatsapp.com/send"], a[href*="wa.me/"], a[href*="whatsapp.com/send"]';
  let scheduled = false;

  function labelWhatsappLinks() {
    scheduled = false;
    document.querySelectorAll(selector).forEach((link) => {
      if (!link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', label);
      }

      if (!link.getAttribute('title')) {
        link.setAttribute('title', label);
      }

      if (link.target === '_blank') {
        const relValues = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        relValues.add('noopener');
        relValues.add('noreferrer');
        link.setAttribute('rel', Array.from(relValues).join(' '));
      }
    });
  }

  function scheduleWhatsappLabeling() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(labelWhatsappLinks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelWhatsappLinks);
  } else {
    labelWhatsappLinks();
  }

  new MutationObserver(scheduleWhatsappLabeling).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
